onDomReady(() => {
   /**
    * Display endpoint details on click.
    */
   const toggleEndpoint = function (ev) {
      const target = ev.target.tagName === 'I' ? ev.target.parentElement : ev.target;
      const icon = target.firstElementChild;
      const expanded = icon.classList.contains('fa-angle-double-up');
      const bodyContent = target.previousElementSibling.querySelector('.bodyContent');

      if (expanded) {
         icon.classList.remove('fa-angle-double-up');
         icon.classList.add('fa-angle-double-down');
         bodyContent.style.display = 'none';
      } else {
         icon.classList.remove('fa-angle-double-down');
         icon.classList.add('fa-angle-double-up');
         bodyContent.style.display = 'block';
      }
   };

   document.querySelectorAll('.toggleContent').forEach(endpoint => {
      endpoint.addEventListener('click', toggleEndpoint);
   });
});
